import { useId, useState } from "react";
import { ACCENT } from "../constants/theme";

export default function Input({
  label,
  type = "text",
  value,
  onChange,
  required,
  placeholder,
  as,
  rows,
}) {
  const [focused, setFocused] = useState(false);
  const inputId = useId();

  const base = {
    width: "100%",
    padding: "12px 16px",
    borderRadius: 10,
    fontSize: 15,
    fontFamily: "inherit",
    border: `1.5px solid ${focused ? ACCENT : "#e2e8f0"}`,
    outline: "none",
    background: "#fff",
    color: "#0f172a",
    transition: "border 0.15s",
    boxSizing: "border-box",
    resize: as === "textarea" ? "vertical" : undefined,
  };

  return (
    <div style={{ marginBottom: 18 }}>
      <label
        htmlFor={inputId}
        style={{
          display: "block",
          fontWeight: 600,
          fontSize: 13.5,
          color: "#374151",
          marginBottom: 6,
        }}
      >
        {label}
        {required && (
          <span style={{ color: ACCENT }} aria-hidden="true">
            {" "}
            *
          </span>
        )}
      </label>

      {as === "textarea" ? (
        <textarea
          id={inputId}
          value={value}
          onChange={onChange}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          placeholder={placeholder}
          rows={rows || 4}
          required={required}
          aria-required={required ? "true" : "false"}
          style={base}
        />
      ) : (
        <input
          id={inputId}
          type={type}
          value={value}
          onChange={onChange}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          placeholder={placeholder}
          required={required}
          aria-required={required ? "true" : "false"}
          style={base}
        />
      )}
    </div>
  );
}